import {
    CREATE_SALES_ORDER_DETAILS_FAILURE,
    CREATE_SALES_ORDER_DETAILS_REQUEST,
    CREATE_SALES_ORDER_DETAILS_SUCCESS,
    CREATE_USER_FORM_SALES_ORDER_DETAILS,
    DELETE_SALES_ORDER_DETAILS_FAILURE,
    DELETE_SALES_ORDER_DETAILS_REQUEST,
    DELETE_SALES_ORDER_DETAILS_SUCCESS,
    FETCH_SALES_ORDER_DETAILS_FAILURE,
    FETCH_SALES_ORDER_DETAILS_REQUEST,
    FETCH_SALES_ORDER_DETAILS_SUCCESS,
    FETCH_SINGLE_SALES_ORDER_DETAILS_FAILURE,
    FETCH_SINGLE_SALES_ORDER_DETAILS_REQUEST,
    FETCH_SINGLE_SALES_ORDER_DETAILS_SUCCESS,
    SALES_ORDER_DETAILS_USERFORM_RESET,
    UPDATE_SALES_ORDER_DETAILS_FAILURE,
    UPDATE_SALES_ORDER_DETAILS_REQUEST,
    UPDATE_SALES_ORDER_DETAILS_SUCCESS,
    SALES_ORDER_DETAILS_USERFORM_DROPDOWNLIST_RESET,
    NAVIGATE_SALES_ORDER,
    FETCH_SALES_ORDER_DETAILS_BY_ID_REQUEST,
    FETCH_SALES_ORDER_DETAILS_BY_ID_SUCCESS,
    FETCH_SALES_ORDER_DETAILS_BY_ID_FAILURE,
    CREATE_USER_FORM_SALES_ORDER_DETAILS_QUANTITY,
    FETCH_SIZE_RATIO_BY_ID_REQUEST,
    FETCH_SIZE_RATIO_BY_ID_SUCCESS,
    FETCH_SIZE_RATIO_BY_ID_FAILURE,
    DROPDOWN_INPUT_GRID_DATA,
    SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_REQUEST,
    SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_SUCCESS,
    SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_FAILURE,
    DROPDOWN_INPUT_GRID_STYLE_MASTER_DATA,
    SUB_STYLE_NUMBER_MULTI_DROPDOWN_REQUEST,
    SUB_STYLE_NUMBER_MULTI_DROPDOWN_SUCCESS,
    SINGLE_SIZE_INFO_BY_ID_REQUEST,
    SINGLE_SIZE_INFO_BY_ID_SUCCESS,
    SINGLE_SIZE_INFO_BY_ID_FAILURE,
    RESET_SINGLE_SIZE_RATIO,
    SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_REQUEST,
    SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_REQUEST,
    SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_SUCCESS,
    SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_FAILURE,
    SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_SUCCESS,
    SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_FAILURE,
    FETCH_STYLE_NUMBER_BY_SEASON_ID_REQUEST,
    FETCH_STYLE_NUMBER_BY_SEASON_ID_SUCCESS,
    FETCH_STYLE_NUMBER_BY_SEASON_ID_FAILURE,
    FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_REQUEST,
    FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_SUCCESS,
    CHECK_FOR_GRID_CHANGES,
    CREATE_USER_FORM_EAN_NUMBER,
    RESET_USER_FORM_EAN_NUMBER,
    SALES_ORDER_DETAILS_EAN_CREATE_FAILURE,
    FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_SUCCESS,
    SALES_ORDER_DETAILS_CHECK_SUCCESS,
    SALES_ORDER_DETAILS_CHECK_REQUEST,
    SALES_ORDER_DETAILS_CHECK_FAILURE,
    FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_FAILURE,
    SALES_ORDER_DETAILS_EAN_CREATE_REQUEST,
    EDIT_MODAL_HEADER_DETAIL,
    SALES_ORDER_RESET_STYLE_GRID,
    CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_REQUEST,
    CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_FAILURE
} from './salesOrderDetails.actionsType';

export const SALES_ORDER_DETAILS = 'salesOrderDetails';

let initialState = {
    loading: false,
    salesOrderList: [],
    salesOrderListById: [],
    styleNumberBySeasonId: [],
    subStyleNumberByStyleNumber: [],
    sizeRatioList: [],
    SodSmDropdown: [],
    subStyleNumberDropdown: [],
    styleMasterDropdownGrid: [],
    singleSizeInfo: null,
    userform: {
        fldPartDevliveryAccept: true,
        fldIsChecked: false

    },
    isChanges: false,
    EANNumber: {},
    singleEANNumber: {},
    userformQuantity: [],
    userformQuantityAdd: [],
    userformDevInputField: [],
    selectedSalesOrder: {},
    isSalesOrder: false,
    singleSalesOrderData: '',
    errorMessage: '',
    editModal: false,
    editScreen: ''
};

export let salesOrderDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    if (type === 'FETCH_SALES_ORDER_DETAILS_BY_ID_SUCCESS') {
        localStorage.setItem('salesOrderListById', updatePayload[0]?.tblStyleMasterId?.fldId)
    }

    switch (type) {
        case FETCH_SALES_ORDER_DETAILS_REQUEST:
        case CREATE_SALES_ORDER_DETAILS_REQUEST:
        case UPDATE_SALES_ORDER_DETAILS_REQUEST:
        case FETCH_SINGLE_SALES_ORDER_DETAILS_REQUEST:
        case DELETE_SALES_ORDER_DETAILS_REQUEST:
        case FETCH_SALES_ORDER_DETAILS_BY_ID_REQUEST:
        case FETCH_SIZE_RATIO_BY_ID_REQUEST:
        case SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_REQUEST:
        case SUB_STYLE_NUMBER_MULTI_DROPDOWN_REQUEST:
        case SINGLE_SIZE_INFO_BY_ID_REQUEST:
        case SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_REQUEST:
        case SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_REQUEST:
        case FETCH_STYLE_NUMBER_BY_SEASON_ID_REQUEST:
        case FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_REQUEST:
        case SALES_ORDER_DETAILS_CHECK_REQUEST:
        case SALES_ORDER_DETAILS_EAN_CREATE_REQUEST:
        case CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_SALES_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderList: updatePayload
            };
        case SALES_ORDER_DETAILS_CHECK_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderCheck: updatePayload
            }
        case EDIT_MODAL_HEADER_DETAIL:
            return {
                ...state,
                loading: false,
                editModal: true,
                editScreen: payload
            }
        case SUB_STYLE_NUMBER_MULTI_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                subStyleNumberDropdown: updatePayload
            };
        case FETCH_SALES_ORDER_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                salesOrderListById: updatePayload
            };
        case FETCH_STYLE_NUMBER_BY_SEASON_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                styleNumberBySeasonId: updatePayload
            };
        case FETCH_SUB_STYLE_NUMBER_BY_STYLE_NUMBER_SUCCESS:
            return {
                ...state,
                loading: false,
                subStyleNumberByStyleNumber: updatePayload
            };

        case SINGLE_SIZE_INFO_BY_ID_SUCCESS:
            return {
                ...state,
                singleSizeInfo: updatePayload,
                loading: false
            };
        case FETCH_SIZE_RATIO_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                sizeRatioList: updatePayload
            };

        case SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                SodSmDropdown: updatePayload
            };

        case CREATE_SALES_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldPartDevliveryAccept: true },
                selectedSalesOrder: {}
            };

        case UPDATE_SALES_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: { fldPartDevliveryAccept: true },
                selectedSalesOrder: {}
            };
        case FETCH_SINGLE_SALES_ORDER_DETAILS_SUCCESS:
            let obj = Object.fromEntries(Object.entries(updatePayload).filter(([k, v]) => k.startsWith('fldQuantity')));
            obj['fldId'] = updatePayload.fldId;
            obj['fldSubStyleNumber'] = updatePayload.tblStyleMasterSubStyleId.fldSubStyleNo;
            obj['fldTotalOrderQty'] = updatePayload.fldTotalOrderQty;
            obj['fldColor'] = updatePayload.tblStyleMasterSubStyleId.fldColour;
            obj['fldS01'] = updatePayload.fldS01;
            obj['fldS02'] = updatePayload.fldS02;
            obj['fldS03'] = updatePayload.fldS03;
            obj['fldS04'] = updatePayload.fldS04;
            obj['fldS05'] = updatePayload.fldS05;
            obj['fldS06'] = updatePayload.fldS06;
            obj['fldS07'] = updatePayload.fldS07;
            obj['fldS08'] = updatePayload.fldS08;
            obj['fldS09'] = updatePayload.fldS09;
            obj['fldS10'] = updatePayload.fldS10;
            obj['fldS11'] = updatePayload.fldS11;
            obj['fldS12'] = updatePayload.fldS12;
            obj['fldS13'] = updatePayload.fldS13;
            obj['fldS14'] = updatePayload.fldS14;
            obj['fldS15'] = updatePayload.fldS15;
            obj['fldS16'] = updatePayload.fldS16;
            obj['fldS17'] = updatePayload.fldS17;
            obj['fldS18'] = updatePayload.fldS18;
            return {
                ...state,
                loading: false,
                userform: updatePayload,
                userformQuantity: [obj],

            };
        case SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_SUCCESS:
            let finalObj = {};
            updatePayload
                .map((element, ind) => {
                    return {
                        ...state.EANNumber,
                        [element.fldSize]: element.fldEaNNumber,
                        [element.fldSize + '1']: element.fldArticleNumber
                    };
                })
                .forEach((element, ind, arr) => {
                    Object.assign(finalObj, arr[ind]);
                });
            return {
                ...state,
                loading: false,
                EANNumber: finalObj
            };

        // ...state.EANNumber,
        //         [updatePayload.fldSize]: updatePayload.fldEaNNumber,
        //         [updatePayload.fldSize + '1']: updatePayload.fldArticleNumber

        case DELETE_SALES_ORDER_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false
            };
        case FETCH_SALES_ORDER_DETAILS_FAILURE:
        case CREATE_SALES_ORDER_DETAILS_FAILURE:
        case UPDATE_SALES_ORDER_DETAILS_FAILURE:
        case FETCH_SINGLE_SALES_ORDER_DETAILS_FAILURE:
        case DELETE_SALES_ORDER_DETAILS_FAILURE:
        case FETCH_SALES_ORDER_DETAILS_BY_ID_FAILURE:
        case FETCH_SIZE_RATIO_BY_ID_FAILURE:
        case SALES_ORDER_DETAILS_STYLE_MASTER_DROPDOWN_FAILURE:
        case SINGLE_SIZE_INFO_BY_ID_FAILURE:
        case SALES_ORDER_DETAILS_BULK_SINGLE_ROW_DELETE_FAILURE:
        case SALES_ORDER_DETAILS_BULK_SINGLE_ROW_INSERT_FAILURE:
        case FETCH_STYLE_NUMBER_BY_SEASON_ID_FAILURE:
        case SALES_ORDER_DETAILS_CHECK_FAILURE:
        case FETCH_SINGLE_SALES_ORDER_DETAILS_EAN_NUMBER_FAILURE:
        case SALES_ORDER_DETAILS_EAN_CREATE_FAILURE:
        case CREATE_SUB_STYLE_NUMBER_MULTI_DROPDOWN_DELETE_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };

        case CREATE_USER_FORM_SALES_ORDER_DETAILS:
            if (payload.key === 'check' && payload.value === true) {
                return {
                    ...state,
                    loading: false,
                    userform: {
                        ...state.userform,
                        fldQuantity: '',
                        [payload.key]: payload.value
                    }
                };
            } else if (payload.key === 'check' && payload.value === false) {
                return {
                    ...state,
                    loading: false,
                    userform: {
                        ...state.userform,
                        fldFkSizeRatio: '',
                        fldFkNumberofBox: '',
                        [payload.key]: payload.value
                    }
                };
            }
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_SALES_ORDER_DETAILS_QUANTITY:
            return {
                ...state,
                userformQuantity: {
                    ...state.userformQuantity,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_EAN_NUMBER:
            return {
                ...state,
                EANNumber: {
                    ...state.EANNumber,
                    [payload.key]: payload.value
                }
            };
        case RESET_USER_FORM_EAN_NUMBER:
            return {
                ...state,
                EANNumber: {}
            };
        case SALES_ORDER_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: { fldPartDevliveryAccept: true },
                userformQuantity: {},
                userformDevInputField: [],
                subStyleNumberDropdown: [],
                EANNumber: {},
                editModal: false,
                editScreen: ''
            };
        case SALES_ORDER_DETAILS_USERFORM_DROPDOWNLIST_RESET:
            return {
                ...state,
                userform: { ...state.userform, BuyName: '' }
            };
        case SALES_ORDER_RESET_STYLE_GRID:
            return {
                ...state,
                userform: { ...state.userform, BuyName: '' },
                userformDevInputField: [],
            }
        case NAVIGATE_SALES_ORDER: {
            return {
                ...state,
                isStyleMaster: false
            };
        }
        case DROPDOWN_INPUT_GRID_DATA: {
            return {
                ...state,
                userformDevInputField: payload,

            };
        }

        case DROPDOWN_INPUT_GRID_STYLE_MASTER_DATA: {
            return {
                ...state,
                styleMasterDropdownGrid: payload
            };
        }
        case RESET_SINGLE_SIZE_RATIO: {
            return {
                ...state,
                singleSizeInfo: null
            };
        }
        case CHECK_FOR_GRID_CHANGES: {
            return {
                ...state,
                isChanges: payload
            };
        }
        default:
            return state;
    }
};
